// The toolbar for the n-way matching cockpit.
// Display two buttons: Approve or Reject.
import { colors } from '@dx-ui/dx-common';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import React from 'react';
import { SaveButton, Toolbar } from 'react-admin';

const i18nKey =
  'dxMessages.task.invoice_matching.invoiceHoldDecisionTask.cockpit.';

// The toolbar of the n-way matching cockpit.
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
const NwayMatchingCockpitToolbar = (props) => {
  const { record } = props;
  if (!record) return null;

  return (
    <Toolbar {...props}>
      <SaveButton
        label={i18nKey + 'button.approve'}
        icon={<ThumbUpIcon />}
        transform={buildRequest('accept')}
        disabled={props.pristine || props.saving}
      />
      <SaveButton
        label={i18nKey + 'button.reject'}
        icon={<ThumbDownIcon />}
        transform={buildRequest('reject')}
        style={{ margin: '2px', backgroundColor: colors.brightOrange }}
        disabled={props.pristine || props.saving}
      />
    </Toolbar>
  );
};

const buildRequest = (action: string) => (props: any) => {
  return {
    input: {
      data: props.input.data,
      action: action,
    },
  };
};

export default NwayMatchingCockpitToolbar;
